import { authFlow } from 'const/session'
import type { AuthFlowType } from 'typings/Auth'
import { setAppSessionItem } from './appSessionItem'
import { setCookie } from './cookie'

const setAuthFlow = (selectedAuthFlow: AuthFlowType): void => {
  setAppSessionItem(authFlow, selectedAuthFlow)
  setCookie(authFlow, selectedAuthFlow)
}

export default setAuthFlow
